import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  standalone: true,
  selector: 'checkout-card-payment-providers',
  templateUrl: './card-payment-providers.component.html',
  styleUrls: ['./card-payment-providers.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule],
})
export class CheckoutCardPaymentProvidersComponent {}
